<template>
  <div class="bg2">
    <!-- <Header title="查看物流" background="#ffffff"></Header> -->
    <div class="comBg">
      <div class="card">
        <p>快递公司</p>
        <p>{{list.expressName}}</p>
      </div>
      <div class="card">
        <p>快递单号</p>
        <p class="flex-between">
          <!-- <span>{{list.expressNo}}</span> -->
		  <span >{{list.expressNo}}</span>
		  <span v-clipboard:copy="list.expressNo"
			  v-clipboard:success="onCopy"
			  v-clipboard:error="onError">复制单号</span>
		  
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
		list:''
	};
  },
  computed: {},
  mounted() {
	  this.list = JSON.parse(this.$route.query.id)
	  console.log(this.list,2)
  	// this.$post({
  	//   url: "/portal/Shop",
  	//   module: "Order",
  	//   interface: "2100",
  	//   data: { id: this.id },
  	// }).then((res) => {
  	//   this.item=res
  	// });
  },
  methods: {
	  onCopy: function (e) {
		this.$toast('复制成功')
	  },
	  onError: function (e) {
		this.$toast('复制失败')
	  }
	  // copyLink() {
	  //      let _this = this;
	  //      let clipboard = new this.clipboard(".cobyOrderSn");
	  //      clipboard.on('success', function () {
	  //        _this.$toast("复制成功")
	  //      });
	  //      clipboard.on('error', function () {
	  //        _this.$toast("复制失败")
	  //      });
	  //  }
  },
};
</script>

<style lang='less' scoped>
.card {
  height: 90px;
  background: #ffffff;
  box-shadow: 0px 0px 16px 0px rgba(96, 98, 102, 0.08);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  color: #303133;
  font-size: 13px;
  padding: 0 14px;
  margin: 14px 0;
  p:nth-child(2) {
    color: #101010;
    font-size: 14px;
  }
  p {
    span:nth-child(2) {
      width: 68px;
      height: 26px;
      background: #ffffff;
      border-radius: 4px;
      border: 1px solid #e63a2a;
      font-size: 12px;
      color: #e63a2a;
      text-align: center;
      line-height: 26px;
    }
  }
}
</style>
